module.exports = __webpack_public_path__ + "static/img/locationMap.0d13b1ac.png";